import { apiService } from './api';
import type { PaginatedResponse } from '../types';
import {
  commissionQuery,
  type Coupon,
  type Commission,
  type CommissionQuery,
  type CommissionTotals,
} from './resellers.service';

export interface ResellerDashboard {
  profile: { name: string; companyName: string | null };
  totals: CommissionTotals;
  coupons: Coupon[];
  customers: Array<{
    organizationId: string;
    businessName: string;
    plan: string | null;
    couponCode: string;
    firstUseDate: string;
    byCurrency: Array<{ currency: string; totalPaid: number; commission: number }>;
    isCurrent: boolean;
  }>;
}
export const resellerService = {
  getDashboard: () => apiService.get<ResellerDashboard>('/reseller/dashboard'),
  getCommissions: (query?: CommissionQuery) =>
    apiService.get<PaginatedResponse<Commission>>(`/reseller/commissions${commissionQuery(query)}`),
};
